import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import currencyCodes from 'currency-codes';
import 'currency-flags/dist/currency-flags.min.css';  // Import the CSS for currency flags
import {addCurrency} from   "./employeesSlice"
import { useDispatch ,useSelector} from 'react-redux';

export default function CurrencySelect({onChange}) {
  const [currency, setCurrency] = useState('PKR');
  console.log("currency", currency)
  const dispatch = useDispatch()
//   const editValue = useSelector((state) => state.employee.editInvoice);
  const { company, companyLoading } = useSelector((state) => state.company);

  const handleChange = (event) => {
    setCurrency(event.target.value)
     dispatch(addCurrency(event.target.value));
     onChange(event.target.value)
  };

  return (
    <FormControl sx={{width:"100%"}}>
      <InputLabel id="currency-select-label">Currency</InputLabel>
      <Select
        labelId="currency-select-label"
        id="currency-select"
        value={company.currency || currency }
        label="Currency"
        onChange={handleChange}
        
      >
        {currencyCodes.codes().map((code) => (
          <MenuItem key={code} value={code}>
            <span className={`currency-flag currency-flag-${code.toLowerCase()}`} style={{ marginRight: 10, }} />
            {code}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
